import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';
import * as Rec from 'fp-ts/Record';
import * as Struct from 'fp-ts/struct';
import { match } from 'ts-pattern';
import * as Api from '../../../api';
const Prop = Api.Product.Property;
const Dimension = Api.Product.Dimension;
export const fromApiProductProperty = (propertyKey, properties) => {
    const topLevelProperty = propertyKey.startsWith('dimension:') ? 'dimension' : propertyKey;
    const p = properties[topLevelProperty];
    return (match(p)
        // TODO: Possibly have individual internal `fromX` style functions for each type of Property, then call them here just for clarity*/
        .when(Prop.isFinish, finish => O.some({
        displayText: finish.name,
        displayImage: pipe(p, Prop.image, O.toUndefined),
        displayColour: pipe(p, Prop.colour, O.toUndefined),
    }))
        .when(Prop.isDimension, dimension => {
        const component = propertyKey === 'dimension:x'
            ? 'x'
            : propertyKey === 'dimension:y'
                ? 'y'
                : propertyKey === 'dimension:z'
                    ? 'z'
                    : undefined;
        const dimensionText = component
            ? Dimension.componentToString(dimension, component)
            : Dimension.toString(dimension);
        return dimensionText
            ? O.some({
                displayText: dimensionText,
            })
            : O.none;
    })
        .when(Prop.isCustom, p => O.some({
        displayText: p.toString(),
    }))
        .otherwise(_ => O.none));
};
/**
 * Concatinates PropertyValues by finding the union of the records.
 *
 * { "White Glossy": { displayText: "X" } } combined with { "Black Glossy": { displayText: "Y" } }
 * results in { "White Glossy": { displayText: "X" },  "Black Glossy": { displayText: "Y" }  }
 *
 * While {  "White Glossy": { displayText: "X" } }  combined with {  "White Glossy": { displayText: "Y" } }
 * results in {  "White Glossy": { displayText: "Y" } }
 **/
export const propertyValuesSemigroup = Rec.getUnionSemigroup(Struct.getAssignSemigroup());
